export default __webpack_public_path__ + "media/images/images_v2/admin-fcd0b2f2e605b90932ebf3d71e10c365.png";